import React from 'react';
import {
  Grid,
  Item,
  Label,
  Icon,
  Segment,
  Header
} from 'semantic-ui-react';
import SandboxedHTMLContent from './SandboxedHTMLContent'
import AttachmentsList from './AttachmentsList'
import mapConnection from '../utils/connectionMapper'

class ReceivedEmail extends React.Component {
  state = { modalOpen: false }

  openModal = () => this.setState({modalOpen: true})

  render = () => {
    const email = this.props.email
    const {
      from,
      subject,
      htmlPart,
      content,
      documentsConnection
    } = email
    const documents = mapConnection(documentsConnection)

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={6}>
            <Item.Meta>From</Item.Meta>
            <Label color='teal' image>
              <Icon name={email.senderType === 'airline' ? 'plane' : 'user'} /> {from}
            </Label>
          </Grid.Column>
          <Grid.Column width={10}>
            <Item.Meta>Subject</Item.Meta>
            <Item.Description>{subject}</Item.Description>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Item.Description className="u-display-linebreak">
              <Segment>
                {htmlPart ?
                  (<SandboxedHTMLContent
                    contentStyle={{
                      width: `100%`,
                      height: `500px`,
                      border: `none`
                    }}
                    documents={documents}
                    htmlPart={htmlPart}/>)
                  :
                  content
                }
              </Segment>
            </Item.Description>
            {documents && documents.length > 0 ?
              <Item.Group>
                <AttachmentsList
                  attachments={documents}
                  onImportToggleClick={this.props.onImportToggleClick}
                  onImportAllToggleClick={this.props.onImportAllToggleClick}
                  buttons={this.props.buttons}
                  toggleImportLabel={this.props.toggleImportLabel}
                />
              </Item.Group> :
              <Item.Group>
                <Segment basic><Header as='h3' textAlign='center'>No attachments</Header></Segment>
              </Item.Group>
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>

    )
  }
}

export default ReceivedEmail;



// WEBPACK FOOTER //
// ./src/component/ReceivedEmail.js